import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddOrEditTicketTagInput, EmployeeDropdownResult, Priority, Result, SubTaskInput, SubTaskResult, TagResult, TicketHasChangedEventInput, TicketLogResult, TicketResult, TicketStatus, TicketTaskResult } from 'app/models';
import { SubTaskService, TicketService, TicketTagService } from 'app/services';
import { Utility } from 'app/shared';

@Component({
  selector: 'app-task',
  templateUrl: './task.component.html',
  styleUrls: ['./task.component.scss']
})
export class TaskComponent implements OnInit {
  public result: Result = new Result();

  public isBusy: boolean;

  public utility = Utility;
  public priority = Priority;
  public ticketStatus = TicketStatus;

  public subtask: SubTaskResult;
  public ticket: TicketResult | null;
  public subTasks: Array<SubTaskResult>;
  public tagIdsForInsert: Array<number>;
  public ticketLogs: Array<TicketLogResult>;

  private idForDelete?: number | null;

  @Input()
  public token: string = '';

  @Input()
  public tags: Array<TagResult>;

  @Input()
  public ticketTaskResult: TicketTaskResult;

  @Input()
  public employeeDropdown: Array<EmployeeDropdownResult>;

  @Output()
  public ticketHasChanged: EventEmitter<TicketHasChangedEventInput>;

  constructor(
    private modalService: NgbModal,
    private ticketService: TicketService,
    private subTaskService: SubTaskService,
    private ticketTagService: TicketTagService) {
    this.ticket = null;
    this.isBusy = false;
    this.idForDelete = null;
    this.result = new Result();
    this.subtask = new SubTaskResult();
    this.tags = new Array<TagResult>();
    this.subTasks = new Array<SubTaskResult>();
    this.tagIdsForInsert = new Array<number>();
    this.ticketLogs = new Array<TicketLogResult>();
    this.ticketTaskResult = new TicketTaskResult();
    this.employeeDropdown = new Array<EmployeeDropdownResult>();
    this.ticketHasChanged = new EventEmitter<TicketHasChangedEventInput>();
  }

  ngOnInit(): void {
  }

  public assigned(employeeId: number): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.ticketService.updateAssignee(this.ticketTaskResult.id, employeeId).then(result => {
        if (result.success === true) {
          this.modalService.dismissAll();
          const ticketHasChangedEventInput = new TicketHasChangedEventInput();
          ticketHasChangedEventInput.assignedEmployeeId = employeeId;
          ticketHasChangedEventInput.id = this.ticketTaskResult.id;
          ticketHasChangedEventInput.ticketStatus = this.ticketTaskResult.ticketStatus;
          ticketHasChangedEventInput.isClosed = false;
          this.ticketHasChanged.emit(ticketHasChangedEventInput);
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public getSubtaskCount(): number {
    return this.subTasks.filter(r => r.isDone === true).length;
  }

  public getSubtaskAssigneeCount(): number {
    return this.subTasks.filter(r => r.isDone === false && r.assignedEmployeeId !== null).length;
  }

  public assignedSubtask(subtaskId: number, employeeId: number): void {
    if (this.isBusy === false) {
      this.subtask = new SubTaskResult();
      this.modalService.dismissAll();
      this.isBusy = true;
      this.subTaskService.updateSubtaskAssignee(subtaskId, employeeId).then(result => {
        this.isBusy = false;
        if (result.success === true) {
          this.showSubTasks();
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public onTicketHasChanged(val: TicketHasChangedEventInput): void {
    this.modalService.dismissAll();
    this.ticketHasChanged.emit(val);
  }

  public createSubTask(): void {
    //const subTaskInput = new SubTaskInput();
    //subTaskInput.ticketId = this.ticketTaskResult.id;
    //subTaskInput.title = '';
    const subTaskResult = new SubTaskResult();
    subTaskResult.id = 0;
    subTaskResult.isDeleted = false;
    subTaskResult.isDone = false;
    subTaskResult.ticketId = this.ticketTaskResult.id;
    subTaskResult.title = '';
    this.subTasks.push(subTaskResult);
  }

  public addSubTask(temp: SubTaskResult): void {
    if (temp.title.trim() !== '') {
      if (this.isBusy === false) {
        this.isBusy = true;
        const subTaskInput = new SubTaskInput();
        subTaskInput.ticketId = this.ticketTaskResult.id;
        subTaskInput.title = temp.title;
        this.subTaskService.addSubTask(subTaskInput).then(result => {
          this.isBusy = false;
          if (result.success === true) {
            this.showSubTasks();
          } else {
            this.result = result;
          }
        }).catch(() => {
          this.isBusy = false;
        });
      }
    }
  }

  public changeToEditMode(temp: SubTaskResult): void {
    temp.oldTitle = temp.title;
    temp.isEditMode = true;
  }

  public cancelSubTask(temp: SubTaskResult): void {
    if (temp.id === 0) {
      this.subTasks = this.subTasks.filter(r => r !== temp);
    } else {
      temp.title = temp.oldTitle;
      temp.isEditMode = false;
    }
  }

  public editSubTask(temp: SubTaskResult): void {
    if (temp.title.trim() !== '') {
      if (this.isBusy === false) {
        this.isBusy = true;
        const subTaskInput = new SubTaskInput();
        subTaskInput.ticketId = this.ticketTaskResult.id;
        subTaskInput.title = temp.title;
        this.subTaskService.editSubTask(temp.id, subTaskInput).then(result => {
          this.isBusy = false;
          if (result.success === true) {
            this.showSubTasks();
          } else {
            this.result = result;
          }
        }).catch(() => {
          this.isBusy = false;
        });
      }
    }
  }

  public deleteSubTask(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.subTaskService.deleteSubTask(this.idForDelete ?? 0).then(result => {
        if (result.success === true) {
          this.modalService.dismissAll();
          this.isBusy = false;
          this.showSubTasks();
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public demonstrateTicket(ticketModal: any): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.ticketService.getTicket(this.ticketTaskResult.id, 'dashboardToken').then(result => {
        this.isBusy = false;

        if (result.success === true) {
          this.ticket = result.data;

          this.modalService.open(ticketModal, {
            centered: true,
            size: 'xl',
            windowClass: 'modal modal-info'
          });
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public demonstrateTicketHistory(ticketHistoryModal: any): void {
    if (this.isBusy === false) {
      this.modalService.open(ticketHistoryModal, {
        centered: true,
        size: 'lg',
        windowClass: 'modal modal-info'
      });
    }
  }

  public hideSubTasks(): void {
    this.subTasks = new Array<SubTaskResult>();
  }

  public showSubTasks(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.subTaskService.getSubTasks(this.ticketTaskResult.id).then(result => {
        if (result.success === true) {
          this.subTasks = result.data;
          this.subTasks.forEach(item => {
            item.oldTitle = '';
            item.isEditMode = false;
          });
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public closeTicket(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.ticketService.updateTicketStatus(this.ticketTaskResult.id, TicketStatus.Closed).then(result => {
        if (result.success === true) {
          const ticketHasChangedEventInput = new TicketHasChangedEventInput();
          ticketHasChangedEventInput.assignedEmployeeId = this.ticketTaskResult.assignedEmployeeId;
          ticketHasChangedEventInput.id = this.ticketTaskResult.id;
          ticketHasChangedEventInput.ticketStatus = this.ticketTaskResult.ticketStatus;
          ticketHasChangedEventInput.isClosed = true;
          this.ticketHasChanged.emit(ticketHasChangedEventInput);
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  public changeIsDone(item: SubTaskResult): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      this.subTaskService.editSubTaskStatus(item.id, item.isDone).then(result => {
        if (result.success === true) {
          this.isBusy = false;
          this.showSubTasks();
        } else {
          this.result = result;
        }
      }).catch(() => {
        this.isBusy = false;
      });
    }
  }

  public openAlertModal(modalDanger: any, id: number): void {
    this.idForDelete = id;
    this.modalService.open(modalDanger, {
      centered: true,
      windowClass: 'modal modal-danger'
    });
  }

  public openAddOreditTagsModal(addOrEditTagsModal: any): void {
    this.tagIdsForInsert = this.ticketTaskResult.tags.map(r => r.id);
    this.modalService.open(addOrEditTagsModal, {
      centered: true,
      windowClass: 'modal modal-info'
    });
  }

  public addOrEditTags(): void {
    if (this.isBusy === false) {
      this.isBusy = true;
      const addOrEditTicketTagInput = new AddOrEditTicketTagInput();
      addOrEditTicketTagInput.tagIds = this.tagIdsForInsert;
      addOrEditTicketTagInput.ticketId = this.ticketTaskResult.id;
      this.ticketTagService.addOrEditTicketTag(addOrEditTicketTagInput).then(result => {
        if (result.success === true) {
          this.loadTags();
          this.modalService.dismissAll();
        } else {
          this.result = result;
        }
      }).finally(() => {
        this.isBusy = false;
      });
    }
  }

  private loadTags(): void {
    this.ticketTagService.getTicketTags(this.ticketTaskResult.id).then(result => {
      if (result.success === true) {
        this.ticketTaskResult.tags = result.data;
      } else {
        this.result = result;
      }
    });
  }

  public showSubtaskDetail(subtaskDetailModal: any): void {
    this.hideSubTasks();
    this.modalService.open(subtaskDetailModal, {
      centered: true,
      windowClass: 'modal modal-info'
    });
  }

  public openSubtaskAssignModal(subtaskAssignModal: any, subtask: SubTaskResult): void {
    this.subtask = subtask;
    this.modalService.open(subtaskAssignModal, {
      centered: true,
      windowClass: 'modal modal-info'
    });
  }
}
